export function createNewTween(scene, target) {
    var tween = scene.tweens.add({
        targets: target,
        scale: 3.7,
        duration: 5000,
        ease: 'Power2',
        loop: 1,
        //paused: true // Start the tween paused
    });
    return tween;
}